var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3, _react_refresh_temp_4;
var _react_refresh_temp_5;
_react_refresh_temp_5 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createSelector } from '@reduxjs/toolkit';
import { store, useAppDispatch, useAppSelector, } from '../../../store';
import { updateIsActiveChatPanel, updateIsActiveSharedNotePad, } from '../../../store/slices/bottomIconsActivitySlice';
import sendAPIRequest from '../../../helpers/api/plugNmeetAPI';
import { ChangeVisibilityRes } from '../../../helpers/proto/plugnmeet_common_api_pb';
const isActiveSharedNotePadSelector = createSelector(_react_refresh_temp_1 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.isActiveSharedNotePad);
$RefreshReg$(_react_refresh_temp_1, "isActiveSharedNotePadSelector$createSelector");
const sharedNotepadStatusSelector = createSelector(_react_refresh_temp_2 = (state) => { var _a; return (_a = state.session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features.shared_note_pad_features; }, (shared_note_pad_features) => shared_note_pad_features === null || shared_note_pad_features === void 0 ? void 0 : shared_note_pad_features.is_active);
$RefreshReg$(_react_refresh_temp_2, "sharedNotepadStatusSelector$createSelector");
const isSharedNotepadVisibleSelector = createSelector(_react_refresh_temp_3 = (state) => { var _a; return (_a = state.session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features.shared_note_pad_features; }, (shared_note_pad_features) => shared_note_pad_features === null || shared_note_pad_features === void 0 ? void 0 : shared_note_pad_features.visible);
$RefreshReg$(_react_refresh_temp_3, "isSharedNotepadVisibleSelector$createSelector");
const SharedNotePadIcon = () => {
    var _a, _b, _c;
    _react_refresh_temp_5();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const showTooltip = store.getState().session.userDeviceType === 'desktop';
    const [iconCSS, setIconCSS] = useState('primaryColor');
    const isActiveSharedNotePad = useAppSelector(isActiveSharedNotePadSelector);
    const sharedNotepadStatus = useAppSelector(sharedNotepadStatusSelector);
    const isVisible = useAppSelector(isSharedNotepadVisibleSelector);
    const [initiated, setInitiated] = useState(false);
    const isAdmin = (_b = (_a = store.getState().session.currentUser) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.is_admin;
    const isRecorder = (_c = store.getState().session.currentUser) === null || _c === void 0 ? void 0 : _c.isRecorder;
    useEffect(() => {
        // if not active then we can disable it.
        if (!sharedNotepadStatus) {
            dispatch(updateIsActiveSharedNotePad(false));
        }
        else {
            dispatch(updateIsActiveSharedNotePad(true));
        }
    }, [sharedNotepadStatus, dispatch]);
    useEffect(() => {
        if (isActiveSharedNotePad) {
            setIconCSS('secondaryColor');
            if (!isRecorder) {
                dispatch(updateIsActiveChatPanel(false));
            }
        }
        else {
            setIconCSS('primaryColor dark:text-darkText');
        }
    }, [isActiveSharedNotePad, dispatch]);
    useEffect(() => {
        if (!sharedNotepadStatus) {
            return;
        }
        if (isVisible) {
            dispatch(updateIsActiveSharedNotePad(true));
        }
        else {
            dispatch(updateIsActiveSharedNotePad(false));
        }
    }, [isVisible]);
    useEffect(() => {
        var _a, _b, _c;
        if (!isAdmin || isRecorder) {
            return;
        }
        const currentRoom = store.getState().session.currentRoom;
        if (!initiated &&
            ((_a = currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features.shared_note_pad_features.visible)) {
            setInitiated(true);
            return;
        }
        else if (!initiated) {
            setInitiated(true);
        }
        const sendRequest = async (body) => {
            await sendAPIRequest('changeVisibility', body.toBinary(), false, 'application/protobuf');
        };
        if (isActiveSharedNotePad &&
            !((_b = currentRoom.metadata) === null || _b === void 0 ? void 0 : _b.room_features.shared_note_pad_features.visible)) {
            const body = new ChangeVisibilityRes({
                roomId: currentRoom.room_id,
                visibleNotepad: true,
            });
            // wait little bit before change visibility
            setTimeout(() => {
                sendRequest(body);
            }, 500);
        }
        else if (!isActiveSharedNotePad &&
            ((_c = currentRoom.metadata) === null || _c === void 0 ? void 0 : _c.room_features.shared_note_pad_features.visible)) {
            const body = new ChangeVisibilityRes({
                roomId: currentRoom.room_id,
                visibleNotepad: false,
            });
            sendRequest(body);
        }
    }, [isActiveSharedNotePad]);
    const text = () => {
        if (isActiveSharedNotePad) {
            return t('footer.icons.hide-shared-notepad');
        }
        else {
            return t('footer.icons.show-shared-notepad');
        }
    };
    const toggleSharedNotePad = async () => {
        dispatch(updateIsActiveSharedNotePad(!isActiveSharedNotePad));
    };
    const render = () => {
        return (_jsxs("div", { className: `shared-notepad h-[35px] lg:h-[40px] w-[35px] lg:w-[40px] relative rounded-full bg-[#F2F2F2] dark:bg-darkSecondary2 hover:bg-[#ECF4FF] ltr:mr-3 lg:ltr:mr-6 rtl:ml-3 lg:rtl:ml-6 flex items-center justify-center cursor-pointer ${showTooltip ? 'has-tooltip' : ''}`, onClick: () => toggleSharedNotePad(), children: [_jsx("span", { className: "tooltip", children: text() }), _jsx(_Fragment, { children: _jsx("i", { className: `pnm-notepad ${iconCSS} text-[14px] lg:text-[16px]` }) })] }));
    };
    return _jsx(_Fragment, { children: sharedNotepadStatus ? render() : null });
};
_react_refresh_temp_4 = SharedNotePadIcon;
$RefreshReg$(_react_refresh_temp_4, "SharedNotePadIcon");
_react_refresh_temp_5(SharedNotePadIcon, "8reUbJvjWCxheHSFLncutxQBmDk=", false, () => [useTranslation, useAppDispatch, useAppSelector, useAppSelector, useAppSelector]);
export default SharedNotePadIcon;
